import { CallBase, ChatBase, ParamsType } from 'rcx_adapter/src/typing';

import { ChannelType } from './constants';
import type { ChannelRuleConfigs } from './types';
import { parseJsonIfValid } from '../util';

const CHANNEL_TYPES = {
    EMAIL: 'EMAIL',
    DIGITAL_SMS: 'DIGITAL_SMS',
    WHATS_APP: 'WHATS_APP',
    ENGAGE_MESSAGING: 'ENGAGE_MESSAGING',
};

export function buildCrmMatchingRule(
    data: CallBase | ChatBase,
    channel: ChannelType,
    crmChannelRuleConfigs: ChannelRuleConfigs
) {
    const config = crmChannelRuleConfigs[channel];
    if (!config) {
        return [];
    }

    return config.getMatchingRules(data as CallBase & ChatBase).matchingRules;
}

export function updateSessionData(data: CallBase | ChatBase, type: string, crmChannelRuleConfigs: ChannelRuleConfigs) {
    if (data?.sessionData) {
        data.sessionData = parseJsonIfValid(data.sessionData);
    }

    const existingMatchingRules = data?.sessionData?.cx?.crm?.matchingRules;
    let crmMatchingRule: any[] = [];

    if (!existingMatchingRules || !existingMatchingRules.length) {
        let channelType = ChannelType.VOICE;
        if (type === ParamsType.CHAT) {
            switch (data?.segmentContext?.dialog?.channelType) {
                case CHANNEL_TYPES.EMAIL:
                    channelType = ChannelType.DIGITAL_EMAIL;
                    break;
                case CHANNEL_TYPES.DIGITAL_SMS:
                case CHANNEL_TYPES.WHATS_APP:
                    channelType = ChannelType.DIGITAL_SMS;
                    break;
                case CHANNEL_TYPES.ENGAGE_MESSAGING:
                    channelType = ChannelType.DIGITAL_MSG;
                    break;
            }
        }

        crmMatchingRule = buildCrmMatchingRule(data, channelType, crmChannelRuleConfigs);

        if (data) {
            data.sessionData = {
                ...data.sessionData,
                cx: {
                    ...data.sessionData?.cx,
                    crm: {
                        ...data.sessionData?.cx?.crm,
                        matchingRules: crmMatchingRule.filter((rule) => rule.crmEntityValue),
                    },
                },
            };
        }
    }
}
